export default __webpack_public_path__ + "static/media/scan.93f235a5.gif";